import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  MAINTENANCE_SERVICE_URI
} from '@leapsight/styleguide'
import { ThingHelpers } from '@/helpers/mainExports'

export default {
  async connectToMaintenanceService(connectionParam) {
    // connectionParam is used in cases where this function is called outside of the established connection's scope
    // (i.e: from the ToolbarAppBox component in the Fleet Management module)
    const countryId = localStorage.getItem('country_id')
    const MAINTENANCE_SERVICE_FLEET_URI =
      countryId === 'ar'
        ? 'https://strix.com.ar/landings/mantenimiento-de-flotas'
        : countryId === 'cl'
        ? 'https://strix.cl/landings/mantenimiento-de-flotas'
        : 'https://strix.uy/landings/mantenimiento-de-flotas'

    const connection = store.getters['auth/connection']
      ? store.getters['auth/connection']
      : connectionParam

    const entities = await ThingHelpers.getEntities({ connection })

    const hasArflotaService =
      entities.filter(
        entity =>
          entity.config?.services?.['mrn:service:arflota']?.status === 'active'
      ).length > 0

    const p1 = new Promise(reject => {
      setTimeout(reject, RACE_TIMEOUT, false)
    })
    const p2 = new Promise((resolve, reject) => {
      const kwArgs = connectionService.createkwArgs()

      if (hasArflotaService) {
        connection?.session
          .call(MAINTENANCE_SERVICE_URI, ['mrn:service:arflota'], kwArgs, {})
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
          .catch(error => {
            return error
          })
      } else {
        resolve(MAINTENANCE_SERVICE_FLEET_URI)
      }
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  }
}
